module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "flex-col text-xs-center"
  }, [_c('v-form', {
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Ingresa tu usuario (email)",
      "type": "email"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchLogin()
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "hide-details": "hide-details",
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingresa tu contraseña"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchLogin()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('v-checkbox', {
    attrs: {
      "light": "light",
      "label": "Permanecer conectado"
    },
    model: {
      value: (_vm.shouldStayLoggedIn),
      callback: function($$v) {
        _vm.shouldStayLoggedIn = $$v
      },
      expression: "shouldStayLoggedIn"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchLogin()
      }
    }
  }, [_vm._v("Ingresar")])], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center mt-4"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("¿Olvidaste tu contraseña?")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "small": "small",
      "text": "text",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/forgot-password-request')
      }
    }
  }, [_vm._v("click aquí")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c42577ca","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login_View.vue
// module id = 528
// module chunks = 1